import React, { useState } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Box, Card, Grid, Typography } from '@mui/material';
import { IconButton, Menu, MenuItem } from '@biq/apex-ui';
import { styles } from '../../../../components/update-page-header/update-page-header-helper';
import {
    SelectedAttributeAssociationProps,
    selectedAttributeAssociationStyles,
} from './edit-edge-definition-helper';

export const SelectedAttributeAssociation = ({
    item,
    onDelete,
}: SelectedAttributeAssociationProps): React.JSX.Element => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLElement>): void => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (): void => {
        setAnchorEl(null);
    };

    const handleDeleteMenuItem = (): void => {
        onDelete(item);
        handleClose();
    };

    return (
        <Card sx={selectedAttributeAssociationStyles.mainContainer}>
            <Grid sx={selectedAttributeAssociationStyles.fromTextContainer}>
                <Typography sx={selectedAttributeAssociationStyles.valueText}>
                    <b>From: </b> {item.attributeAssociation.leftSideValue}
                </Typography>
            </Grid>
            <Grid sx={selectedAttributeAssociationStyles.toTextContainer}>
                <Typography sx={selectedAttributeAssociationStyles.valueText}>
                    <b>To: </b> {item.attributeAssociation.rightSideValue}
                </Typography>
            </Grid>
            <Grid sx={selectedAttributeAssociationStyles.menuContainer}>
                <IconButton
                    sx={styles.iconButtonStyles}
                    id='edge-definition-menu-button'
                    aria-controls={open ? 'edge-definition-menu' : undefined}
                    aria-expanded={open ? 'true' : undefined}
                    aria-label='menu-button'
                    aria-haspopup='true'
                    onClick={handleClick}
                >
                    <MoreVertIcon />
                </IconButton>
                <Menu
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    id='delete-edge-definition-menu'
                    aria-labelledby='edge-definition-delete-button'
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    sx={selectedAttributeAssociationStyles.menu}
                >
                    <MenuItem onClick={handleDeleteMenuItem}>
                        <Box sx={styles.deleteMenuItemContainer}>
                            <DeleteIcon sx={styles.deleteIconStyles} />
                            <Typography sx={styles.deleteTextStyles}>
                                Remove
                            </Typography>
                        </Box>
                    </MenuItem>
                </Menu>
            </Grid>
        </Card>
    );
};
